import Box from '@components/Box';
import ErrorIcon from '@assets/icons/error.svg';
import { getErrorCode, getErrorArguments, isApiErrorWithResponse } from '@api/apiClient';
import { isAdmin } from '@utils/auth';
import { Row } from '@components/Grid';
import { Text, TextColor, TextSize } from '@components/Text';
import { useTranslation } from 'react-i18next';

function FormErrorMessage({ errorPrefix, error, defaultError, black, context, noPt }: {
  errorPrefix?: string,
  defaultError?: string,
  error: any,
  black?: boolean,
  context?: Record<string, string | ((data: Record<string, string>) => string)>,
  noPt?: boolean
}) {
  const { t } = useTranslation();
  const prefix = errorPrefix ?? "apiErrors";
  const isThisAdmin = isAdmin();

  let errorMessage = t(
    `${prefix}.default${isThisAdmin ? "-isAdmin" : ""}`,
    { defaultValue: t(defaultError ?? "defaultFormErrors.default") },
  );
  if (isApiErrorWithResponse(error)) {
    const args = getErrorArguments(error);
    const stringArgs = Object.keys(context ?? {})
      .reduce((acc: Record<string, string>, key: string) => {
        const item = context?.[key] ?? "";
        acc[key] = String(typeof item === "function" ? item(args) : item);
        return acc;
      }, {} as Record<string, string>);
    errorMessage = t(
      `${prefix}.${getErrorCode(error, "")}`,
      {
        defaultValue: errorMessage,
        ...args,
        ...stringArgs,
      },
    );
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  return (
    <Row>
      <Box pt={noPt ? 0 : 2} flex="column">
        <div style={{
          alignItems: 'center',
          columnGap: 5,
          display: 'flex'
        }}>
          <img
              alt="Error"
              src={ErrorIcon}
          />
          <Text
              color={black ? TextColor.PRIMARY : TextColor.ERROR}
              dangerouslySetInnerHTML={{
                __html: errorMessage,
              }}
              size={TextSize.S}
          />
        </div>
        {isThisAdmin ? (
          <Text
            color={black ? TextColor.PRIMARY : TextColor.ERROR}
            dangerouslySetInnerHTML={{
              __html: t(`${prefix}.defaultAdminDescription`, {
                defaultValue: "",
              }),
            }}
          />
        ) : null}
      </Box>
    </Row>
  )
}

export default FormErrorMessage
